import { useContext } from 'react';
import { AppContext } from '../components/AppContext';
import { getLocalization } from '../localization';
import { useAnnotator } from './useAnnotator';

export const useLocalization = (locale?: string) => {
    const annotator = useAnnotator();
    const { documentMetadata, localeObject } = useContext(AppContext);
    const loc = getLocalization(locale || documentMetadata.locale, '', {}, annotator, localeObject);

    return loc;
};
